import type { WretchError } from 'wretch/resolver'

import { type ErrorResponseJson } from './api'

export const isString = (v: unknown): v is string => typeof v === 'string'
export const isNumber = (v: unknown): v is number => typeof v === 'number'
export const isBoolean = (v: unknown): v is boolean => typeof v === 'boolean'

export const isObject = (v: unknown): v is Record<string, unknown> =>
  typeof v === 'object' && !Array.isArray(v) && v !== null

export const isWretchError = (e: Error): e is WretchError => isObject(e) && !!e?.status && !!e?.response

export const isApiErrorResponse = (response: unknown): response is ErrorResponseJson =>
  isObject(response) && 'code' in response && 'description' in response
